import { createQueryClient } from '../query-client';
import { createAuthClient } from './auth-client';

export const queryClient = createQueryClient();
export const authClient = createAuthClient();
